









import Vue from "vue"
import { layoutMap, LayoutBroker } from "@bgov/vue-layouts"

export default Vue.extend({
  components: {
    LayoutBroker: LayoutBroker,
  },
  data() {
    return {
      layoutMap,
    }
  },
  computed: {
    layout(): string {
      /*
       * When the app first loads, the initial route is not initialized
       * on the first tick through this function, which means that the
       * default route will be initalized even if it's not the correct
       * destination.  Since the default route includes some remote
       * lookups to bootstrap the navigation, this loading could
       * delay requests required for the actual resolved layout, so
       * we return a bogus one here so that it doesn't get loaded by
       * default.
       *
       * Note that this will have to change if we ever get to a place
       * where root path of BGOV is served by this application, but
       * that's likely years and a couple different client side
       * frameworks away ;-) 
      */
      if (this.$route.fullPath === "/") {
        return ""
      }

      return this.$route.meta.layout || "default"
    },
  },
  watch: {
    "$auth.currentUser": function() {
      if (this.$auth.currentUser) {
        this.$analytics.identify(this.$auth.currentUser.uuid)
      } else {
        this.$analytics.reset()
      }
    },
  },
})
